<template>
  <el-dialog
      :visible="true"
      width="13.1rem"
      title="培训情况"
      append-to-body
      @close="$emit('close')"
  >
    <div class="order-list-detail">
      <el-button
          type="primary"
          @click="exportStudent"
          size="mini"
          style="margin-bottom: 16px"
      >导出
      </el-button
      >
      <el-table :data="tableList" v-loading="isLoading" style="width: 100%">
        <el-table-column type="index" label="序号" :index="indexMethod" align="center">
        </el-table-column>
        <el-table-column prop="trainingName" label="培训班名称" align="center">
        </el-table-column>
        <el-table-column prop="courseName" label="课程名称" align="center"></el-table-column>
        <el-table-column prop="userName" label="学员姓名" align="center"></el-table-column>
        <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
        <el-table-column label="学习进度" align="center">
          <template slot-scope="scope">
            <span :class="[scope.row.browseScore ? 'process' : '']">{{
                scope.row.browseScore
              }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="credit" label="获得学时" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <span
                :class="[+scope.row.status == 1 ? 'status-pass' : 'un-pass']"
            >{{ +scope.row.status == 1 ? "完成" : "未完成" }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="startDate" label="选课时间" align="center"></el-table-column>
        <el-table-column prop="endTime" label="完成时间" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrappper">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      />
    </div>
  </el-dialog>
</template>

<script>
import {downloadExcelFile, exportstudentData, getStudengtCountTrainingList} from "@/api/order";

export default {
  props: {
    activeData: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      tableList: [],
      pageNum: 1,
      total: 0,
      isLoading: false,
      pageSize: 10,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getData();
    },
    getData() {
      this.isLoading = true;
      getStudengtCountTrainingList({
        trainingId: this.activeData.trainingId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        phone: this.activeData.phone,
      })
          .then((res) => {
            const {total = 0, records = []} = res;
            this.total = total;
            this.tableList = records;
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    exportStudent() {
      const url = `${process.env.VUE_APP_BASE_API}${exportstudentData}?trainingId=${this.activeData.trainingId}&phone=${this.activeData.phone}`;
      console.log(url)
      // window.open(url);

      // this.isLoading = true
      const downloadUrl = `${process.env.VUE_APP_BASE_API}${exportstudentData}`;
      const fileName = "学员培训情况.xlsx";
      const param = {
        trainingId: this.activeData.trainingId,
        phone: this.activeData.phone
      };
      downloadExcelFile(downloadUrl, fileName,param)

      // downloadExcel(`${process.env.VUE_APP_BASE_API}${exportstudentData}`, {
      //   trainingId: this.activeData.trainingId,
      //   phone: this.activeData.phone
      // }).then((blob) => {
      //   // 下载
      //   if (blob instanceof Blob) {
      //     let eLink = document.createElement("a");
      //     eLink.download = "学员培训情况.xlsx";
      //     eLink.style.display = "none";
      //     eLink.href = URL.createObjectURL(blob);
      //     document.body.appendChild(eLink);
      //     eLink.click();
      //
      //     document.body.removeChild(eLink);
      //     URL.revokeObjectURL(eLink.href);
      //   }
      // }).finally(() => {
      //   this.isLoading = false;
      // });

    },
    indexMethod(index) {
      return index + (this.pageNum - 1) * this.pageSize + 1;
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-dialog__header) {
  font-size: 0;
  padding: 0.28rem 0.35rem 0;

  .el-dialog__headerbtn {
    font-size: 0.28rem;
  }
}

:deep(.el-dialog__body) {
  padding: 0.18rem 0.35rem;
}

.top-filter {
  display: flex;
  font-size: 0.16rem;

  .item {
    display: flex;
    align-items: center;
    margin-right: 0.4rem;

    .label {
      white-space: nowrap;
    }

    .radio-content {
      margin-left: 0.27rem;
      display: flex;
      color: #333;

      .child {
        display: flex;
        margin-right: 0.33rem;
        align-items: center;
        cursor: pointer;

        .icon {
          width: 0.22rem;
          height: 0.21rem;
          margin-right: 0.1rem;
          background-image: url(../../../../../assets/images/unchecked.png);
          background-size: cover;

          &.checked {
            background-image: url(../../../../../assets/images/checked.png);
          }
        }
      }
    }
  }
}

.order-list-detail {
  min-height: 2rem;

  :deep(.el-table__header) {
    tr {
      th {
        background-color: rgba(0, 114, 255, 0.1) !important;
        color: rgba(0, 114, 255, 1);
        padding: 0.06rem 0;
      }
    }
  }

  :deep(.el-table__body) {
    tr {
      td {
        background-color: #fff !important;
        padding: 0.06rem 0;
      }
    }
  }

  .finish-status {
    color: rgba(255, 137, 0, 1);
  }

  .status-pass {
    color: rgba(35, 200, 136, 1);
  }

  .un-pass {
    color: rgba(235, 18, 19, 1);
  }

  .process {
    color: rgba(35, 200, 136, 1);
  }
}

.pagination-wrappper {
  margin-top: 0.16rem;
  text-align: center;
}
</style>